import { useState, useRef } from 'react';
import { stateNames as toastDownloadStateNames } from "../components/common/Toast";

const downloadCsvRequest = async (metricId) => {
    let url = `https://services-375925469890.us-central1.run.app/download/metrics/${metricId}`;
    return fetch(url, { method: 'GET' });
}

const useCsvDownload = () => {
    const csvBlobRef = useRef(null);
    const downloadCsvTimeout = useRef(null);
    const [downloadCsvState, setCsvState] = useState(null);

    const setDownloadCsvState = (state) => {
        setCsvState(state);

        downloadCsvTimeout.current && clearTimeout(downloadCsvTimeout.current);
        if (state === toastDownloadStateNames.success || state === toastDownloadStateNames.error) {
            downloadCsvTimeout.current = setTimeout(() => setCsvState(null), 10000);
        }
    }

    const onHandleDownloadCsvFile = async (metricId) => {
        setDownloadCsvState(toastDownloadStateNames.isLoading);
        await downloadCsvRequest(metricId)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Download failed: ${response.status}`);
                }
                return response.blob();
            })
            .then(blobFile => {
                setDownloadCsvState(toastDownloadStateNames.success);
                csvBlobRef.current = blobFile;
                downloadCsvFile(blobFile, metricId);
            })
            .catch(err => {
                setDownloadCsvState(toastDownloadStateNames.error);
                console.log(err);
            });
    }

    const downloadCsvFile = async (blobFile, metricId) => {
        try {
            // Get the filename from the response headers or use a default
            let filename = 'metrics_results.csv';

            const element = document.createElement('a');
            element.href = URL.createObjectURL(blobFile);
            element.download = filename;
            document.body.appendChild(element);
            element.click();
            URL.revokeObjectURL(element.href);

            setDownloadCsvState(null);
        } catch (e) {
            console.log(e);
        }
    }

    return {
        downloadCsvFile,
        onHandleDownloadCsvFile,
        downloadCsvState,
        csvBlob: csvBlobRef.current
    };
};

export default useCsvDownload;
